import React from 'react'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import SelectCustom from '../../atoms/select/SelectCustom'
import { Grid } from '@mui/material'

const DJMusician = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>DJ/Musician Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label htmlFor="type" className={styles.label}>
								Type
							</label>
							<InputCustom
								id="type"
								name="type"
								placeholder="e.g., DJ, live band, string quartet, etc."
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfPerformers"
								className={styles.label}
							>
								Number of performers
							</label>
							<InputCustom
								id="numberOfPerformers"
								name="numberOfPerformers"
								placeholder="Enter number of performers"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="equipmentProvidedBy"
								className={styles.label}
							>
								Equipment provided by
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'self', label: 'self' },
									{ value: 'venue', label: 'venue' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Timeline Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="arrivalTime"
								className={styles.label}
							>
								Arrival/load-in time
							</label>
							<InputCustom
								id="arrivalTime"
								name="arrivalTime"
								placeholder="HH:MM"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="soundCheckTime"
								className={styles.label}
							>
								Sound check time
							</label>
							<InputCustom
								id="soundCheckTime"
								name="soundCheckTime"
								placeholder="HH:MM"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="coverageHours"
								className={styles.label}
							>
								Coverage hours
							</label>
							<InputCustom
								id="coverageHours"
								name="coverageHours"
								placeholder="HH:MM"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="musicStartTime"
								className={styles.label}
							>
								Music start & end time:
							</label>
							<InputCustom
								id="musicStartTime"
								name="musicStartTime"
								placeholder="HH:MM"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="breakSchedule"
								className={styles.label}
							>
								Break schedule:
							</label>
							<InputCustom
								id="breakSchedule"
								name="breakSchedule"
								placeholder="HH:MM"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Key Moments</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label htmlFor="cueFor" className={styles.label}>
								Cue for
							</label>
							<InputCustom
								id="cueFor"
								name="cueFor"
								placeholder="Enter cue for"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="powerNeeds"
								className={styles.label}
							>
								Power needs
							</label>
							<InputCustom
								id="powerNeeds"
								name="powerNeeds"
								placeholder="Enter power needs"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupSpaceSize"
								className={styles.label}
							>
								Setup space size
							</label>
							<InputCustom
								id="setupSpaceSize"
								name="setupSpaceSize"
								placeholder="Enter setup space size"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupSpaceSize"
								className={styles.label}
							>
								Coordination with MC or planner?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'self', label: 'self' },
									{ value: 'venue', label: 'venue' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingency"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingency"
								name="rainContingency"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupDuration"
								name="setupDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipment"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipment"
								name="specialEquipment"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default DJMusician
